(() => {
  const SELECTOR = '[data-firera-necklace-guide]';

  const initializeGuide = (root) => {
    if (!root || root.dataset.initialized === 'true') return;

    const dialog = root.querySelector('[data-firera-necklace-guide-dialog]');
    const openButton = root.querySelector('[data-firera-necklace-guide-open]');
    const closeButton = root.querySelector('[data-firera-necklace-guide-close]');
    if (!dialog || !openButton || !closeButton) return;

    let previousFocus = null;

    const openGuide = () => {
      previousFocus = document.activeElement;

      try {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      } catch (error) {
        dialog.setAttribute('open', '');
      }

      dialog.classList.add('is-open');
      document.documentElement.classList.add('firera-size-guide-open');
      window.requestAnimationFrame(() => closeButton.focus());
    };

    const closeGuide = () => {
      dialog.classList.remove('is-open');

      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');

      document.documentElement.classList.remove('firera-size-guide-open');
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    };

    openButton.addEventListener('click', openGuide);
    closeButton.addEventListener('click', closeGuide);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeGuide();
    });
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeGuide();
    });
    dialog.addEventListener('close', () => {
      dialog.classList.remove('is-open');
      document.documentElement.classList.remove('firera-size-guide-open');
    });

    root.dataset.initialized = 'true';
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.(SELECTOR)) initializeGuide(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(initializeGuide);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
